var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVectorSmartObject8(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 91.566,
    height: 80,
    viewBox: "0 0 91.566 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_91",
    "data-name": "Rectangle 91",
    width: 91.566,
    height: 80,
    transform: "translate(0 0.001)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vector_Smart_Object",
    "data-name": "Vector Smart Object",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_146",
    "data-name": "Group 146"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_145",
    "data-name": "Group 145",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_324",
    "data-name": "Path 324",
    d: "M56.31,61.59A17.221,17.221,0,0,1,46.19,64.6,17.2,17.2,0,0,1,36.076,61.59a20.081,20.081,0,0,0-11.764-3.468,19.518,19.518,0,0,0-8.622,1.75L4.256,34.12l18.922,2.164,8.2,6.872a1.576,1.576,0,0,0,.892.372l52.6,4.716L83.748,56.5a6.588,6.588,0,0,1-3.85,5.146h-.056a19.716,19.716,0,0,0-11.774-3.524A20.04,20.04,0,0,0,56.31,61.59M38,27.412l29.9,3.16a1.63,1.63,0,1,0,.34-3.242l-2.99-.316,1-8.434,12.478,1.312L80.912,44.63,33.1,40.344,29.912,37.7ZM89.946,64.6A16.764,16.764,0,0,1,83.22,63.38,9.938,9.938,0,0,0,86.948,56.9L88.326,47a1.618,1.618,0,0,0-1.46-1.832L84.2,44.922l-2.356-26.65A1.62,1.62,0,0,0,80.392,16.8l-3.37-.358L78.5,1.79a1.628,1.628,0,0,0-3.24-.324l-1.45,14.642L65,15.176a1.621,1.621,0,0,0-1.79,1.426l-1.182,10.08L37.446,24.09A1.619,1.619,0,0,0,36,24.7L27.43,35.62l-2.544-2.13a1.621,1.621,0,0,0-.858-.366L1.81,30.572a1.621,1.621,0,0,0-1.67,2.27l12.7,28.578-.284.17A17.231,17.231,0,0,1,2.434,64.6a1.621,1.621,0,1,0,0,3.242A20.1,20.1,0,0,0,14.2,64.376a17.278,17.278,0,0,1,10.114-3.014,17.252,17.252,0,0,1,10.112,3.014,20.127,20.127,0,0,0,11.766,3.47,20.125,20.125,0,0,0,11.764-3.47,17.278,17.278,0,0,1,10.114-3.014A17.252,17.252,0,0,1,78.18,64.376a20.127,20.127,0,0,0,11.766,3.47,1.621,1.621,0,0,0,0-3.242",
    fill: "#82decf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_325",
    "data-name": "Path 325",
    d: "M40.008,35.23l3.962.43h.17a1.623,1.623,0,0,0,.18-3.242l-3.964-.43a1.63,1.63,0,0,0-.348,3.242",
    fill: "#82decf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_326",
    "data-name": "Path 326",
    d: "M51.2,36.4l3.954.43h.178a1.623,1.623,0,1,0,.17-3.242l-3.954-.43A1.63,1.63,0,1,0,51.2,36.4",
    fill: "#82decf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_327",
    "data-name": "Path 327",
    d: "M62.112,37.594l3.954.422h.178a1.623,1.623,0,1,0,.178-3.242l-3.962-.43a1.63,1.63,0,0,0-.348,3.242Z",
    fill: "#82decf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328",
    "data-name": "Path 328",
    d: "M74.12,71.086a21.489,21.489,0,0,0-6.052-.81A20.108,20.108,0,0,0,56.3,73.744,17.179,17.179,0,0,1,46.19,76.758a17.2,17.2,0,0,1-10.114-3.014,20.086,20.086,0,0,0-11.764-3.468,21.219,21.219,0,0,0-6.306.866,1.621,1.621,0,1,0,.95,3.1,18.1,18.1,0,0,1,5.356-.722A17.237,17.237,0,0,1,34.424,76.53,20.055,20.055,0,0,0,46.19,80a20.053,20.053,0,0,0,11.764-3.47,17.278,17.278,0,0,1,10.114-3.014,18.528,18.528,0,0,1,5.144.658,1.621,1.621,0,0,0,.908-3.088",
    fill: "#82decf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_329",
    "data-name": "Path 329",
    d: "M17.018,42.726a1.621,1.621,0,1,1-1.62-1.62,1.621,1.621,0,0,1,1.62,1.62",
    fill: "#82decf"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorSmartObject8);
export default __webpack_public_path__ + "static/media/Vector Smart Object (8).4a63689101806c80b89ceb4c7fad1640.svg";
export { ForwardRef as ReactComponent };